<template>
	<div>
		<sFilter ref="filter" @updateTab="filter"></sFilter>
		<sBox :tabs="tabs" type="tabs" v-model="tab">
			<div v-if="tab == 'app-sst'" slot="tools">
				<button
					class="btn btn-primary btn-sm"
					:disabled="btn_check"
					@click="force_verify"
				>
					<span v-if="btn_check">
						<i class="fa fa-spin fa-spinner"></i>
						Verificando...
					</span>
					<span v-else> Verificar Pagamento </span>
				</button>
			</div>
			<div slot="body">
				<sTable
					ref="tab"
					actionRead="private-read-sstContracts"
					actionDelete="private-delete-sstContracts"
					:labels="labels"
					:actions="cmpActions"
					:functions="functions"
					:tags="tags"
					:lineStatus="fxStatus"
					@edit="(data) => $refs.modal.open(data)"
					@AbrirEmpresa="AbrirEmpresa"
				/>
			</div>
		</sBox>
		<modal ref="modal" @updateStatusContract="$refs.tab.updateTable()" />
		<modal-empresa ref="ModalEmpresa" disabled />
	</div>
</template>
<script>
	import aBtn from 'btn';
	import sBox from 'box';
	import sTable from 'table';
	import toastr from 'toastr';

	import eDate from 'js/date';
	import pad from 'js/pad';
	import images from './js/images.js';

	import modal from './components/modal.vue';
	import sFilter from './components/filter.vue';
	import cmpActions from './components/actions.vue';
	import ModalEmpresa from '../cadastros/customers/modal.vue';

	export default {
		name: 'Contracts',
		components: {
			sTable,
			sBox,
			aBtn,
			modal,
			sFilter,
			cmpActions,
			ModalEmpresa,
		},
		data() {
			return {
				cmpActions: cmpActions,
				tabs: [
					{ cod: 'gestor-web', title: 'Gestor Web' },
					{ cod: 'petronet', title: 'Petronet' },
					{ cod: 'app-sst', title: 'Aplicativo SST' },
				],
				tab: 'gestor-web',
				functions: [
					{
						cod: 'cod',
						fx: (val, row, ff) => {
							if (row.cod_interno != '') return row.cod_interno;
							else return pad(val, 5);
						},
					},
					{
						cod: 'data',
						fx: (val) => {
							return eDate(val, 'DD/MM/YY');
						},
					},
					{
						cod: 'valor',
						fx: (val) => {
							return 'R$ ' + parseFloat(val).toFixed(2);
						},
					},

					{
						cod: 'payment',
						fx: (val, line) => {
							if (Array.isArray(val)) {
								const status = {
									DINHEIRO: `<span class="label label-default">Dinheiro</span>`,
									BOLETO: `<span class="label label-success">Boleto</span>`,
									CHEQUE: `<span class="label label-warning">Cheque</span>`,
									'CATÃO DE CRÉDITO': `<span class="label label-primary">Cartão de Crédito</span>`,
									'CARTÃO DE DÉBITO': `<span class="label label-info">Cartão de Débito</span>`,
									PIX: `<span class="label label-info">Pix</span>`,
									'': `<span class="label label-danger">Indefinido</span>`,
								};
								return status[
									line.cod_proposta.forma_pagamento
								];
							} else {
								return `<img class='logos-dos-cartoes' src='${
									images[val.tPaymentMethodId]
								}'>`;
							}
						},
					},
					{
						cod: 'regiao',
						fx: (val, line) => {
							return `<span class='label label-success'>
							<i class='fa fa-map-marker'></i> ${line.cod_proposta.regiao}
						</span>`;
						},
					},
					{
						cod: 'tipo',
						fx: (val, line) => {
							return `<span class='label label-${
								line.cod_proposta.new == 0
									? 'warning'
									: 'success'
							}'>
							${line.cod_proposta.new == 0 ? 'Alterado/Renovado' : 'Novo'}
						</span>`;
						},
					},
				],
				btn_check: false,
			};
		},
		computed: {
			labels() {
				if (this.tab != 'gestor-web') {
					return [
						{ data: 'cod', label: 'Num' },
						{
							event: 'AbrirEmpresa',
							data: [
								'cod_proposta.cnpj.razao_social',
								'cod_proposta.cnpj.cnpj',
							],
							label: 'Razão social / CNPJ',
							two: true,
						},
						{ data: 'regiao', label: 'Região' },
						{ data: 'data', label: 'Data' },
						{ data: 'payment', label: 'F.Pagto' },
						{ data: 'payment.tStatus', label: 'S.Pagto' },
						{ data: 'tipo', label: 'Origem' },
						{ data: 'status', label: 'Situação' },
						{ data: 'valor', label: 'Total', class: 'warning' },
					];
				} else {
					return [
						{ data: 'cod', label: 'Num' },
						{
							event: 'AbrirEmpresa',
							data: [
								'cod_proposta.cnpj.razao_social',
								'cod_proposta.cnpj.cnpj',
							],
							label: 'Razão social / CNPJ',
							two: true,
						},
						{ data: 'regiao', label: 'Região' },
						{ data: 'data', label: 'Data' },
						{ data: 'payment', label: 'F.Pagto' },

						{ data: 'tipo', label: 'Origem' },
						{ data: 'status', label: 'Situação' },
						{ data: 'valor', label: 'Total', class: 'warning' },
					];
				}
			},
			tags() {
				let tags = [
					{
						cod: 'status',
						value: 'moderacao',
						html: 'Moderação',
						color: 'warning',
					},
					{
						cod: 'status',
						value: 'distribuido',
						html: 'Ativo',
						color: 'primary',
					},
					{
						cod: 'status',
						value: 'concluido',
						html: 'Concluído',
						color: 'success',
					},
					{
						cod: 'status',
						value: 'ativo',
						html: 'Iniciado',
						color: 'info',
					},
					{
						cod: 'status',
						value: 'suspenso',
						html: 'Suspenso',
						color: 'danger',
					},
				];
				if (this.tab != 'gestor-web') {
					tags.push({
						cod: 'payment.tStatus',
						value: 'approved',
						html: 'Aprovado',
						color: 'success',
					});
					tags.push({
						cod: 'payment.tStatus',
						value: 'rejected',
						html: 'Rejeitado',
						color: 'danger',
					});
					tags.push({
						cod: 'payment.tStatus',
						value: 'pending',
						html: 'Pendente',
						color: 'warning',
					});
					tags.push({
						cod: 'payment.tStatus',
						value: 'awaiting_processing',
						html: 'Pendente',
						color: 'warning',
					});
					tags.push({
						cod: 'payment.tStatus',
						value: '',
						html: 'FATURA',
						color: 'default',
					});
				}
				return tags;
			},
		},
		watch: {
			tab: function () {
				this.filter();
			},
		},
		provide() {
			return {
				updateTab: () => this.$refs.tab.updateTable(),
				openMdCliente: (e) => this.$refs.ModalEmpresa.open(),
			};
		},
		methods: {
			AbrirEmpresa(emp) {
				this.$refs.ModalEmpresa.open(emp.cod_proposta.cnpj);
				// console.log(emp.cod_proposta.cnpj)
			},
			fxStatus(row) {
				if (row.status == 'suspenso') return 'danger';
			},
			filter(val = null) {
				let search = '';

				if (this.tab == 'gestor-web')
					search = ' ( info = "W10=" and cod_interno = "" ) ';
				else if (this.tab == 'petronet')
					search = ' ( info = "W10=" and cod_interno != "" ) ';
				else if (this.tab == 'app-sst')
					search = ' ( info != "W10=" and cod_interno = "" ) ';

				if (val == null) val = search;
				else {
					if (Array.isArray(val)) val.push(search);
					else val += ` and ${search}`;
				}

				this.$refs.tab.setFilter(val);
				console.log('🗿🍷 ~ val:', val);
				this.$refs.tab.updateTable();
			},
			force_verify() {
				this.btn_check = true;
				$.get(
					'http://wbs.viasst.com.br/crons/payments_verification/index.php?no_history'
				).then((resp) => {
					this.btn_check = false;
					try {
						resp = window.atob(resp);
						resp = JSON.parse(resp);
						if (
							resp[resp.last_event] != undefined &&
							resp[resp.last_event].status != 0 &&
							resp[resp.last_event].status == 200
						) {
							toastr.success(
								'Conferência realizada com sucesso!'
							);
							this.$refs.tab.updateTable();
						} else {
							toastr.error(
								'Não foi possível realizar a conferência!'
							);
						}
					} catch (e) {
						toastr.error(
							'Não foi possível realizar a conferência!'
						);
					}
				});
			},
		},
		mounted() {
			this.$refs.filter.update();
			this.$emit('setHeader', ['Gerenciamento de Contratos', '']);
		},
	};
</script>
<style>
	.logos-dos-cartoes {
		width: 25px;
	}
</style>



// WEBPACK FOOTER //
// src/components/contracts/index.vue